import { SET_TIMEOUT_VALUE } from "../../../../constants/app-constants";
import { withApollo } from "react-apollo";
import React from "react";
import {
  getListofPrivilegeQuery,
  deletePrivilegeQuery,
} from "../../../../services/graphql/queries/roles";
import PrivilegeAdd from "./PrivilegeAdd";
import PrivilegeModify from "./PrivilegeModify";
import ReactModal from "../../../Common/ReactModal";
import { PAGINATION_OFFSET_VALUE } from "../../../../constants/app-constants";
import Pagination from "../../../Common/Pagination";
import add from "../../../../static/images/svg/Add.svg";
import Modify from "../../../../static/images/svg/Modify.svg";
import Delete from "../../../../static/images/svg/Delete.svg";
import Success from "../../../../static/images/svg/Success.svg";
class Privilege extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedRecord: null,
      listOfPrivilege: [],
      isListMode: true,
      isSuccess: false,
      loading: false,
      errors: [],
      error: "",
      pageOfItems: [],
      currentPage: 1,
      offset: PAGINATION_OFFSET_VALUE,
      reactModalVisible: false,
      requireCancel: true,
      modalMessage: "Are you sure you want to delete",
      deleteId: "",
      Roles_Privilege_Feature_ID: 173,
      isDelete: false,
      userTypes: {
        1: "Admin",
        4: "Info Portal",
      },
    };

    this.modify = this.modify.bind(this);
    this.delete = this.delete.bind(this);
    this.switchToAddMode = this.switchToAddMode.bind(this);
    this.listMode = this.listMode.bind(this);
    this.switchToListMode = this.switchToListMode.bind(this);
    this.deletePrivilege = this.deletePrivilege.bind(this);
    this.addPrivilege = this.addPrivilege.bind(this);
    // this.onOkClicked = this.onOkClicked.bind(this);
  }

  modify(e, id) {
    if (
      this.props.accessSpecifier[this.state.Roles_Privilege_Feature_ID].editP
    ) {
      e.preventDefault();

      console.log("Modify: ", id);

      const selectedRecords = this.state.listOfPrivilege.filter((element) => {
        return element._id === id ? true : false;
      });

      console.log(selectedRecords);

      this.setState({
        selectedRecord: selectedRecords[0],
        isListMode: false,
      });
    } else {
      this.setState({
        reactModalVisible: true,
        modalMessage: "You dont have permission to do this Action",
        requireCancel: false,
      });
    }
  }

  delete(e, id) {
    if (
      this.props.accessSpecifier[this.state.Roles_Privilege_Feature_ID].deleteP
    ) {
      e.preventDefault();
      console.log("Delete: ", id);

      //Use this ID and make a graphql call to delete
      this.setState({
        reactModalVisible: true,
        modalMessage: "Are you sure you want to delete",
        requireCancel: true,
        deleteId: id,
        isDelete: true,
      });
    } else {
      this.setState({
        reactModalVisible: true,
        modalMessage: "You dont have permission to do this Action",
        requireCancel: false,
      });
    }
  }
  deletePrivilege() {
    this.setState({ reactModalVisible: false });
    this.props.client
      .mutate({
        mutation: deletePrivilegeQuery,
        variables: {
          id: this.state.deleteId,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        this.switchToListMode();
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, errors: error.message });
      });
  }
  onOkClicked() {
    if (this.state.isDelete) {
      this.deletePrivilege();
    }
    this.setState({ reactModalVisible: false });
  }

  onCancelClicked() {
    this.setState({ reactModalVisible: false });
  }

  switchToAddMode() {
    this.setState({ selectedRecord: null });
  }

  listMode(mode) {
    this.setState({ isListMode: mode, selectedRecord: null });
  }

  switchToListMode() {
    this.setState({ loading: true, isSuccess: true });
    console.log(this.props.userId);
    this.props.client
      .query({
        query: getListofPrivilegeQuery,
        variables: {
          roleId: this.props.user.Id,
          offset: this.state.offset,
          pageNo: this.state.currentPage,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        const user = result.data.getListofFunctions;

        this.initialState = {
          listOfPrivilege: JSON.parse(user),
        };

        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
    setTimeout(() => {
      this.setState({ isSuccess: false });
    }, SET_TIMEOUT_VALUE);
  }

  onChangePage(currentPage) {
    // update state with new page of items
    this.setState({
      currentPage: currentPage,
      loading: true,
    });
    this.getListofPrivilegeQuery(this.state.offset, currentPage);
  }
  addPrivilege() {
    if (
      this.props.accessSpecifier[this.state.Roles_Privilege_Feature_ID].createP
    ) {
      this.listMode(false);
    } else {
      this.setState({
        reactModalVisible: true,
        modalMessage: "You dont have permission to do this Action",
        requireCancel: false,
      });
    }
  }
  getListofPrivilegeQuery(offset, pageNo) {
    this.props.client
      .query({
        query: getListofPrivilegeQuery,
        variables: {
          roleId: this.props.user.Id,
          offset: offset,
          pageNo: pageNo,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        const user = result.data.getListofFunctions;
        this.initialState = {
          listOfPrivilege: JSON.parse(user),
        };

        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        // console.log("~~~error: ", error);
        // this.setState({ loading: false });
        // error.graphQLErrors.map(({ message }, i) => {
        //   this.setState(prevState => {
        //     return { errors: [message] };
        //   });
        // });
        // setTimeout(() => {
        //   this.setState({ errors: [] });
        // }, SET_TIMEOUT_VALUE);

        console.log("~~~error: ", error);
        this.setState({
          loading: false,
          error: error.message,
          listOfPrivilege: [],
        });
      });
  }

  componentDidMount() {
    this.setState({ loading: true });
    if (this.props.user && this.props.user.Id) {
      this.getListofPrivilegeQuery(this.state.offset, this.state.currentPage);
    }
  }

  render() {
    const { userId } = this.props;
    const {
      selectedRecord,
      listOfPrivilege,
      isSuccess,
      reactModalVisible,
      requireCancel,
      modalMessage,
      errors,
      loading,
      error,
      userTypes,
    } = this.state;
    return (
      <div
        className="tab-pane fade show active"
        id="specs"
        role="tabpanel"
        aria-labelledby="specs-tab"
      >
        <div className="box-card">
          <div className="row">
            <div className="col-md-12">
              {this.state.isListMode ? (
                <div>
                  {/* List View Start */}
                  <div className="row align-items-center">
                    <div className="col-md-10">
                      <h1 className="heading">Privilege List View </h1>
                    </div>
                    <div className="col-md-2 text-right">
                      <a
                        href="#"
                        className="link-click m-l-45"
                        onClick={this.addPrivilege}
                      >
                        <svg
                          x="0px"
                          y="0px"
                          width="16px"
                          height="16px"
                          viewBox="0 0 16 16"
                          enableBackground="new 0 0 16 16"
                          xmlSpace="preserve"
                        >
                          <g>
                            <circle
                              fill="none"
                              stroke="#69951a"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              cx={8}
                              cy={8}
                              r="7.5"
                            />
                            <g>
                              <line
                                fill="none"
                                stroke="#69951a"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit={10}
                                x1="2.5"
                                y1={8}
                                x2="13.5"
                                y2={8}
                              />
                              <line
                                fill="none"
                                stroke="#69951a"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit={10}
                                x1={8}
                                y1="2.5"
                                x2={8}
                                y2="13.5"
                              />
                            </g>
                          </g>
                        </svg>{" "}
                        Add
                      </a>
                    </div>
                  </div>

                  <div
                    className="alert alert-success p-0 m-t-10 m-b-0"
                    role="alert"
                  >
                    {isSuccess ? (
                      <span>
                        <img src={Success} /> Success
                      </span>
                    ) : null}
                  </div>
                  {/* Table Section Start */}
                  <div className="table-responsive">
                    <>
                      <table className="table table-style-1 m-t-35">
                        <thead>
                          <tr>
                            <th>DESCRIPTION</th>
                            <th>VIEW</th>
                            <th>EDIT</th>
                            <th>CREATE</th>
                            <th>DELETE</th>
                            <th>USER TYPE</th>
                            <th>ACTION(s)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {listOfPrivilege.length
                            ? listOfPrivilege.map((data, index) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      {data.FeatureId &&
                                      data.FeatureId.description
                                        ? data.FeatureId.description
                                        : ""}
                                    </td>
                                    <td>
                                      {data && data.viewP ? (
                                        <div
                                          className="checkbox-style-1"
                                          style={{ marginTop: "-20px" }}
                                        >
                                          <div className="form-check form-check-inline">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="inlineCheckbox1"
                                              value="option1"
                                              readOnly
                                              checked={
                                                data && data.viewP
                                                  ? true
                                                  : false
                                              }
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor="inlineCheckbox1"
                                            />
                                          </div>
                                        </div>
                                      ) : (
                                        <div>NA</div>
                                      )}
                                    </td>
                                    <td>
                                      {data && data.editP ? (
                                        <div
                                          className="checkbox-style-1"
                                          style={{ marginTop: "-20px" }}
                                        >
                                          <div className="form-check form-check-inline">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="inlineCheckbox2"
                                              value="option2"
                                              readOnly
                                              checked={
                                                data && data.editP
                                                  ? true
                                                  : false
                                              }
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor="inlineCheckbox2"
                                            />
                                          </div>
                                        </div>
                                      ) : (
                                        <div>NA</div>
                                      )}
                                    </td>
                                    <td>
                                      {data && data.createP ? (
                                        <div
                                          className="checkbox-style-1"
                                          style={{ marginTop: "-20px" }}
                                        >
                                          <div className="form-check form-check-inline">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="inlineCheckbox3"
                                              value="option3"
                                              readOnly
                                              checked={
                                                data && data.createP
                                                  ? true
                                                  : false
                                              }
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor="inlineCheckbox3"
                                            />
                                          </div>
                                        </div>
                                      ) : (
                                        <div>NA</div>
                                      )}
                                    </td>
                                    <td>
                                      {data && data.deleteP ? (
                                        <div
                                          className="checkbox-style-1"
                                          style={{ marginTop: "-20px" }}
                                        >
                                          <div className="form-check form-check-inline">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="inlineCheckbox4"
                                              value="option4"
                                              readOnly
                                              checked={
                                                data && data.deleteP
                                                  ? true
                                                  : false
                                              }
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor="inlineCheckbox4"
                                            />
                                          </div>
                                        </div>
                                      ) : (
                                        <div>NA</div>
                                      )}
                                    </td>
                                    <td>
                                      {data.userType
                                        ? userTypes[data.userType]
                                        : ""}
                                    </td>
                                    <td>
                                      <a
                                        href="#"
                                        className="link-primary"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        title="Modify"
                                        onClick={(e) => {
                                          this.modify(e, data._id);
                                        }}
                                      >
                                        <img src={Modify} />
                                      </a>
                                      <a
                                        href="#"
                                        className="link-delete m-l-45"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        title="Delete"
                                        onClick={(e) => {
                                          this.delete(e, data._id);
                                        }}
                                      >
                                        <img src={Delete} />
                                      </a>
                                    </td>
                                  </tr>
                                );
                              })
                            : // <div
                              //   style={{ textAlign: "right", fontSize: "14px" }}
                              // >
                              //   {!listOfPrivilege.length && error
                              //     ? error
                              //     : "No Data"}
                              // </div>
                              null}
                        </tbody>
                      </table>
                      {/* {!listOfPrivilege.length && error ? <div>{error}</div> : null} */}
                      {/* {!listOfPrivilege.length && loading ? <div>Fetching...</div> : null} */}
                      {!listOfPrivilege.length && !error ? (
                        <div style={{ textAlign: "center" }}>No Data</div>
                      ) : null}
                      <Pagination
                        loading={loading}
                        items={listOfPrivilege}
                        pageSize={this.state.offset}
                        initialPage={this.state.currentPage}
                        onChangePage={this.onChangePage.bind(this)}
                      />
                    </>
                  </div>
                  {/* Table Section End */}
                  {/* List View End */}
                </div>
              ) : (
                <div>
                  {/* Add New Role View Start */}
                  {selectedRecord ? (
                    <PrivilegeModify
                      userId={userId}
                      selectedRecord={selectedRecord}
                      switchToAddMode={this.switchToAddMode}
                      switchToListMode={this.switchToListMode}
                      listMode={this.listMode}
                    />
                  ) : (
                    <PrivilegeAdd
                      user={this.props.user}
                      userId={userId}
                      switchToListMode={this.switchToListMode}
                      listMode={this.listMode}
                    />
                  )}
                  {/* Add New Role End */}
                </div>
              )}
            </div>
          </div>
        </div>
        <ReactModal
          reactModalVisible={reactModalVisible}
          submitModal={this.onOkClicked.bind(this)}
          closeModal={this.onCancelClicked.bind(this)}
          modalMessage={modalMessage}
          requireCancel={requireCancel}
        />
      </div>
    );
  }
}

export default withApollo(Privilege);
